import React from 'react';
import { useSelector } from 'react-redux';

const Jejaring = () => {
    const jejaringInstansi = useSelector(state => state.data.jejaringInstansi);

    return (
        <section className="py-16 bg-white">
            <div className="container mx-auto px-4">
                <h2 className="section-title">Jejaring Instansi Terkait</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
                    {jejaringInstansi.map((instansi) => (
                        <a
                            key={instansi.id}
                            href={instansi.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex flex-col items-center p-6 card-glass hover:transform hover:scale-105 transition-all duration-300"
                        >
                            <img
                                src={instansi.logo}
                                alt={instansi.name}
                                className="w-18 h-18 object-contain mb-4"
                            />
                            <p className="text-sm text-center text-gray-700 font-semibold">
                                {instansi.name}
                            </p>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Jejaring;